/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0",
    versionName: "0.2.0",
    versionChannel: "stable",
    buildDate: "2026-05-16T14:17:30.783Z",
    commitHash: "b001ac439e9cf1a860116f3cfe1b85d2881228c3",
};
